module.exports = __webpack_public_path__ + "static/remote-5ba23460fcb680b51dcf44dc8b318352.png";